export const RECON_LOADED = 'RECON_LOADED'
export const RECON_LOADING = 'RECON_LOADING'
export const RECON_COMPANYLIST_LOADED = 'RECON_COMPANYLIST_LOADED'
export const RECON_COMPANY_SELECTED = 'RECON_COMPANY_SELECTED'
export const RECON_SELECTED = 'RECON_SELECTED'
export const RECON_DETAILS_LOADED = 'RECON_DETAILS_LOADED'
export const RECON_UPLOADING_LOADED = 'RECON_UPLOADING_LOADED'
export const RECON_UPLOADING_LOADING = 'RECON_UPLOADING_LOADING'
export const RECON_UPLOAD_UPDATE = 'RECON_UPLOAD_UPDATE'
export const RECON_UPLOADING_FAILED = 'RECON_UPLOADING_FAILED'
export const RECON_UPLOAD_CLEARED = 'RECON_UPLOAD_CLEARED'
export const INVOICE_LOADING = 'INVOICE_LOADING'
export const INVOICE_DETAILS_LOADED = 'INVOICE_DETAILS_LOADED'
export const INVOICE_DETAILS_LOADING_ERROR = 'INVOICE_DETAILS_LOADING_ERROR'
export const RECON_RE_UPLOADING_LOADED = 'RECON_RE_UPLOADING_LOADED'
export const RECON_RE_UPLOADING_FAILED = 'RECON_RE_UPLOADING_FAILED'
export const RECON_UPLOAD_INVOICE_UPDATE = 'RECON_UPLOAD_INVOICE_UPDATE'
export const ESS_RECON_COMPANYLIST_LOADED = 'ESS_RECON_COMPANYLIST_LOADED'
